export default "__VITE_ASSET__DcI_ZSkz__"